import { connect } from 'react-redux';

import ChecklistItem from './checklistItem';
import {
  onLoadChecklists,
  selectChecklist,
  onSubmitChecklistItemAnswer,
  onSubmitChecklist,
  onRestartChecklist,
  selectResult,
  onExportChecklistContent,
  onUpdateScore,
} from '../../reducers/checklist.reducers';

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  onUpdateScore: (checked) => dispatch(onUpdateScore(checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistItem);



// WEBPACK FOOTER //
// ./src/app/main/checklist/checklistItem.container.js